import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function Reports() {
  const [reports, setReports] = useState(null);

  useEffect(() => {
    api('/ats/reports').then(r => r.ok ? r.json() : null).then(setReports).catch(() => {});
  }, []);

  if (!reports) return <Layout><div className="text-center py-12 text-gray-500">Loading...</div></Layout>;

  const maxStage = Math.max(...Object.values(reports.byStage || {}), 1);
  const maxSource = Math.max(...Object.values(reports.bySource || {}), 1);

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Reports</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {[
          { label: 'Total Jobs', value: reports.totalJobs, color: 'text-gray-900' },
          { label: 'Open Jobs', value: reports.openJobs, color: 'text-teal-600' },
          { label: 'Total Applicants', value: reports.totalApplicants, color: 'text-blue-600' },
          { label: 'Avg Time to Hire', value: reports.avgTimeToHireDays != null ? `${reports.avgTimeToHireDays}d` : '—', color: 'text-amber-600' },
        ].map(s => (
          <div key={s.label} className="bg-white rounded-lg shadow p-6">
            <p className="text-sm text-gray-500">{s.label}</p>
            <p className={`text-3xl font-bold ${s.color}`}>{s.value}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">By Stage</h3>
          <div className="space-y-3">
            {Object.entries(reports.byStage || {}).map(([stage, count]) => (
              <div key={stage}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="capitalize text-gray-700">{stage}</span>
                  <span className="text-gray-500">{count} ({reports.conversionRates?.[stage] ?? 0}%)</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2">
                  <div className="bg-teal-500 h-2 rounded-full" style={{ width: `${(count / maxStage) * 100}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">By Source</h3>
          <div className="space-y-3">
            {Object.entries(reports.bySource || {}).map(([source, count]) => (
              <div key={source}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-gray-700">{source}</span>
                  <span className="text-gray-500">{count}</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2">
                  <div className="bg-blue-500 h-2 rounded-full" style={{ width: `${(count / maxSource) * 100}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
